import React, { useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { ServiceSelection } from './ServiceSelection';
import { BookingCalendar } from './BookingCalendar';
import { BackButton } from '../common/BackButton';
import type { SelectedFeatures } from '../../data/pricing';

export function BookingFlow() {
  const [searchParams] = useSearchParams();
  const initialService = searchParams.get('service');
  const initialModel = searchParams.get('model') as 'Build & Maintain' | 'Build & Bounce' | null;
  
  const [selectedFeatures, setSelectedFeatures] = useState<SelectedFeatures[]>(
    initialService && initialModel ? [{
      serviceId: initialService as any,
      model: initialModel,
      features: new Set()
    }] : []
  );
  const [showCalendar, setShowCalendar] = useState(false);

  const handleServiceSelection = (selected: SelectedFeatures[]) => {
    setSelectedFeatures(selected);
    setShowCalendar(true);
  };

  const handleBack = () => {
    setShowCalendar(false);
  };

  return (
    <div className="min-h-screen bg-gradient-to-b from-black via-black/95 to-black py-24">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <BackButton label="Back" />
        
        {!showCalendar ? (
          <ServiceSelection 
            initialSelected={selectedFeatures}
            onComplete={handleServiceSelection} 
          />
        ) : (
          <BookingCalendar 
            selectedFeatures={selectedFeatures}
            onBack={handleBack}
          />
        )}
      </div>
    </div>
  );
}